export const triggerAdjustRegistrationEvent = () => {};
export const triggerAdjustApplicationEvent = () => {};
export const triggerAdjustTrustedJobAppEvent = () => {};
export const triggerAdjustOnApplicationCreationEvent = () => {};
export const trackSkillAdjustEvent = () => {};
